var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"myContainer"},[(_vm.isValid)?_c('Navbar',{staticClass:"myContainer"}):_vm._e(),_c('v-main',{staticClass:"myContainer"},[_c('router-view',{staticClass:"myContainer"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }